import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import './index.css';
import { router } from './router';
import { initAuth } from './auth/msal';
import { redirectToCanonicalHost } from './auth/canonical';
import { initTelemetry } from './telemetry/appInsights';

// フロント計装を初期化（VITE_APPINSIGHTS_CONNECTION_STRING 未設定なら no-op）
initTelemetry();

// 既定の SWA ホストで開かれた場合は正規ドメインへ寄せる（認証より前に実行）。
// リダイレクト中は以降の処理を行わない。
if (!redirectToCanonicalHost()) {
  // MSAL モードでは初回にリダイレクト応答処理＋未ログイン時はログインへ送る。
  // header モード（dev既定）では initAuth は即 true を返す。
  initAuth().then((ready) => {
    if (!ready) return; // ログインリダイレクト中は描画しない
    createRoot(document.getElementById('root')!).render(
      <StrictMode>
        <RouterProvider router={router} />
      </StrictMode>,
    );
  });
}
